export const AG_GRID_LOCALE_ES = {

  //Set Filter					
  selectAll: '(Seleccionar Todo)',
  selectAllSearchResults: '(Seleccionar Todos los Resultados de Búsqueda)',
  searchOoo: 'Búsqueda…',
  blanks: '(Espacios en Blanco)',
  noMatches: 'No hay coincidencias',

  // Number Filter & Text Filter					
  filterOoo: 'Filtro…',
  equals: 'Igual a',
  notEqual: 'No es igual',
  blank: 'En blanco',
  notBlank: 'No en blanco',
  empty: 'Elija Uno',

  //Number Filter					
  lessThan: 'Menor que',
  greaterThan: 'Mayor que',
  lessThanOrEqual: 'Menor que o igual',
  greaterThanOrEqual: 'Mayor que o igual',
  inRange: 'En el rango',
  inRangeStart: 'Desde',
  inRangeEnd: 'Hasta',

  // Text Filter					
  contains: 'Contiene',
  notContains: 'No contiene',
  startsWith: 'Empieza con',
  endsWith: 'Termina con',

  // Date Filter					
  dateFormatOoo: 'dd-mm-yyyy',

  // Filter Conditions					
  andCondition: 'Y',
  orCondition: 'O',

  // Filter Buttons					
  applyFilter: 'Aplicar',
  resetFilter: 'Restablecer',
  clearFilter: 'Despejar',
  cancelFilter: 'Cancelar',

  // Filter Titles					
  textFilter: 'Filtro de Texto',
  numberFilter: 'Filtro de Número',
  dateFilter: 'Filtro de Fecha',
  setFilter: 'Establecer Filtro',

  // Side Bar					
  columns: 'Columnas',
  filters: 'Filtros',

  // columns tool panel					
  pivotMode: 'Modo Dinámico',
  groups: 'Grupo de Filas',
  rowGroupColumnsEmptyMessage: 'Arrastre aquí para establecer grupos de filas',
  values: 'Valores',
  valueColumnsEmptyMessage: 'Arrastre aquí para establecer',
  pivots: 'Etiquetas de Columna',
  pivotColumnsEmptyMessage: 'Arrastre aquí para establecer etiquetas de columnas',

  // Header of the Default Group Column					
  group: 'Grupo',

  // Row Drag					
  rowDragRows: 'filas',

  // Other					
  loadingOoo: 'Cargando…',
  noRowsToShow: 'No hay filas que mostrar',
  enabled: 'Activado',

  // Menu					
  pinColumn: 'Fijar Columna',
  pinLeft: 'Fijar Izquierda',
  pinRight: 'Fijar Derecha',
  noPin: 'Sin Fijar',
  valueAggregation: 'Agregación de Valor',
  autosizeThiscolumn: 'Autodimensionar Esta Columnas',
  autosizeAllColumns: 'Autodimensionar Todas las Columnas',
  groupBy: 'Agrupar por',
  ungroupBy: 'Desagrupar por ',
  addToValues: 'Agregar ${variable} a los Valores',
  removeFromValues: 'Eliminar ${variable} de los Valores',
  addToLabels: 'Agregar ${variable} a las etiquetas',
  removeFromLabels: 'Eliminar ${variable} de las etiquetas',
  resetColumns: 'Restablecer Columnas',
  expandAll: 'Expandir Todo',
  collapseAll: 'Cerrar Todo',
  copy: 'Copiar',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'Copiar con Cabeceras',
  copyWithGroupHeaders: 'Copiar con Cabeceras de Grupo',
  paste: 'Pegar',
  ctrlV: 'Ctrl+V',
  export: 'Exportar',
  csvExport: 'Exportar CSV',
  excelExport: 'Exportar Excel',

  // Enterprise Menu Aggregation and Status Bar					
  sum: 'Suma',
  min: 'Mínimo',
  max: 'Máximo',
  none: 'Ninguno',
  count: 'Contar',
  avg: 'Promedio',
  filteredRows: 'Filtrado',
  selectedRows: 'Seleccionado',
  totalRows: 'Filas Totales',
  totalAndFilteredRows: 'Filas',
  more: 'Más',
  to: 'para',
  of: 'de',
  page: 'Página',
  nextPage: 'Siguiente Página',
  lastPage: 'Última Página',
  firstPage: 'Primera Página',
  previousPage: 'Página Anterior',

  // Pivoting					
  pivotColumnGroupTotals: 'Total',

  // Enterprise Menu (Charts)					
  pivotChartAndPivotMode: 'Gráfico Dinámico y Modo Dinámico',
  pivotChart: 'Gráfico Dinámico',
  chartRange: 'Rango del Gráfico',
  columnChart: '',
  groupedColumn: '',
  stackedColumn: '',
  normalizedColumn: '',
  barChart: 'Barra',
  groupedBar: 'Agrupada',
  stackedBar: 'Apilada',
  normalizedBar: '100% Apilada',
  pieChart: 'Circular',
  pie: 'Circular',
  doughnut: 'Rosca',
  line: 'Línea',
  xyChart: 'X Y (Dispersión)',
  scatter: 'Dispersión',
  bubble: 'Burbuja',
  areaChart: 'Área',
  area: 'Área',
  stackedArea: 'Apilada',
  normalizedArea: '100% Apilada',
  histogramChart: 'Histograma',
  combinationChart: 'Combinación',
  columnLineCombo: 'Columna y Línea',
  AreaColumnCombo: 'Área y Columna',

  // Charts					
  pivotChartTitle: 'Gráfico Dinámico',
  rangeChartTitle: 'Gráfico de Rango',
  settings: 'Ajustes',
  data: 'Datos',
  format: 'Formato',
  categories: 'Categorías',
  defaultCategory: '(Ninguno)',
  series: 'Serie',
  xyValues: 'Valores X Y',
  paired: 'Modo Emparejado',
  axis: 'Eje',
  navigator: 'Navegador',
  color: 'Color',
  thickness: 'Espesor',
  xType: 'Tipo X',
  automatic: 'Automático',
  category: 'Categoría',
  number: 'Número',
  time: 'Tiempo',
  autoRotate: 'Auto Rotar',
  xRotation: 'Rotación en X',
  yRotation: 'Rotación en Y',
  ticks: 'Marcas',
  width: 'Ancho',
  height: 'Altura',
  length: 'Longitud',
  padding: 'Relleno',
  spacing: 'Espaciado',
  chart: 'Gráfico',
  title: 'Título',
  titlePlaceholder: 'Título del gráfico - doble click para editar',
  background: 'Fondo',
  font: 'Fuente',
  top: 'Arriba',
  right: 'Derecha',
  bottom: 'Abajo',
  left: 'Izquierda',
  labels: 'Etiquetas  ',
  size: 'Tamaño',
  minSize: 'Tamaño Mínimo',
  maxSize: 'Tamaño Máximo',
  legend: 'Leyenda',
  position: 'Pocisión',
  markerSize: 'Tamaño del Marcador',
  markerStroke: 'Trazo del Marcador',
  markerPadding: 'Relleno del Marcador',
  itemSpacing: 'Espacio entre Elementos',
  ItemPaddingX: 'Relleno del Elemento X',
  ItemPaddingY: 'Relleno del Elemento Y',
  layoutHorizontalSpacing: 'Espaciado Horizontal',
  layoutVerticalSpacing: 'Espaciado Vertical',
  strokeWidth: 'Anchura del Trazo',
  lineDash: 'Guión de Línea',
  offset: 'Compensar',
  offsets: 'Compensaciones',
  tooltips: 'Cuadro de Sugerencias',
  callout: 'Aviso',
  markers: 'Marcadores',
  shadow: 'Sombra',
  blur: 'Desenfoque',
  xOffset: 'Compensar en X',
  yOffset: 'Compensar en Y',
  lineWidth: 'Ancho de Línea',
  normal: 'Normal',
  bold: 'Negrita',
  italic: 'Cursiva',
  boldItalic: 'Negrita Cursiva',
  predefined: 'Predefinido',
  fillOpacity: 'Opacidad de Relleno',
  strokeOpacity: 'Opacidad de Línea',
  histogramBinCount: 'Conteo de Papeleras',
  columnGroup: 'Columna',
  barGroup: 'Barra',
  pieGroup: 'Circular',
  lineGroup: 'Línea',
  scatterGroup: 'X Y (Dispersión)',
  areaGroup: 'Área  ',
  histogramGroup: 'Histograma',
  combinationGroup: 'Combinación',
  groupedColumnTooltip: 'Agrupado',
  stackedColumnTooltip: 'Apilado',
  normalizedColumnTooltip: '100% Apilado',
  groupedBarTooltip: 'Agrupado',
  stackedBarTooltip: 'Apilado',
  normalizedBarTooltip: '100% Apilado',
  pieTooltip: 'Circular',
  doughnutTooltip: 'Rosca',
  lineTooltip: 'Línea',
  groupedAreaTooltip: 'Área',
  stackedAreaTooltip: 'Apilada',
  normalizedAreaTooltip: '100% Apilada',
  scatterTooltip: 'Disepersa',
  bubbleTooltip: 'Burbuja',
  histogramTooltip: 'Histograma',
  columnLineComboTooltip: 'Columna & Línea',
  areaColumnComboTooltip: 'Área & Columna',
  customComboTooltip: 'Combinación Personalizada',
  noDataToChart: 'No hay datos disponibles para ser graficados',
  pivotChartRequiresPivotMode: 'El gráfico dinámico requiere que el modo dinámico esté activado',
  chartSettingsToolbarTooltip: 'Menú',
  chartLinkToolbarTooltip: 'Vinculado a la Cuadrícula',
  chartUnlinkToolbarTooltip: 'Desvinculado de la Cuadrícula',
  chartDownloadToolbarTooltip: 'Gráfico de Descarga',
  seriesChartType: 'Tipo de Gráfico de Serie',
  seriesType: 'Tipo de Serie',
  secondaryAxis: 'Eje Secundario',

  // ARIA					
  ariaChecked: 'comprobado',
  ariaColumn: 'Columna',
  ariaColumnGroup: 'Grupo de Columnas',
  ariaColumnList: 'Lista de Columnas',
  ariaColumnSelectAll: 'Alternar la Selección de Todas las Columnas',
  ariaDateFilterInput: 'Entrada del Filtro de Fecha',
  ariaDefaultListName: 'Lista  ',
  ariaFilterColumnsInput: 'Entrada de Columnas de Filtrado',
  ariaFilterFromValue: 'Filtrar Desde el Valor',
  ariaFilterInput: 'Entrada de Filtro',
  ariaFilterList: 'Lista de Filtros',
  ariaFilterToValue: 'Filtro a Valor',
  ariaFilterValue: 'Valor del Filtro',
  ariaFilteringOperator: 'Operador de Filtrado',
  ariaHidden: 'oculto',
  ariaIndeterminate: 'indeterminado',
  ariaInputEditor: 'Editor de Entradas',
  ariaMenuColumn: 'Pulse CTRL + ENTER para abrir el menú de la columna.',
  ariaRowDeselect: 'Pulse SPACE para deseleccionar esta fila',
  ariaRowSelectAll: 'Pulse Space para aleternar la selección de todas las filas',
  ariaRowToggleSelection: 'Pulse Space para alternar la selección de filas',
  ariaRowSelect: 'Pulse SPACE para seleccionar esta fila',
  ariaSearch: 'Búsqueda',
  ariaSortableColumn: 'Pulse ENTER para ordenar',
  ariaToggleVisibility: 'Pulse ENTER para alternar la visibilidad',
  ariaUnchecked: 'sin comprobar',
  ariaVisible: 'visible',
  ariaSearchFilterValues: 'Valores del filtro de búsqueda',

  // ARIA Labels for Drop Zones					
  ariaRowGroupDropZonePanelLabel: 'Grupo de Filas',
  ariaValuesDropZonePanelLabel: 'Valores',
  ariaPivotDropZonePanelLabel: 'Etiquetas de Columna',
  ariaDropZoneColumnComponentDescription: 'Pulse DELETE para eliminar',
  ariaDropZoneColumnValueItemDescription: 'Presione ENTER para cambiar el tipo de agregación',
  ariaDropZoneColumnGroupItemDescription: 'Presione ENTER para ordenar',

  // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeperator}{column name}					
  ariaDropZoneColumnComponentAggFuncSeperator: 'de',
  ariaDropZoneColumnComponentSortAscending: 'ascendente',
  ariaDropZoneColumnComponentSortDescending: 'descendente',

  // ARIA Labels for Dialogs					
  ariaLabelColumnMenu: 'Menú de Columnas',
  ariaLabelCellEditor: 'Editor de Celdas',
  ariaLabelDialog: 'Diálogo',
  ariaLabelSelectField: 'Seleccionar Campo',
  ariaLabelTooltip: 'Cuadro de Sugerencia',
  ariaLabelContextMenu: 'Menú de Contexto',
  ariaLabelSubMenu: 'Submenú ',
  ariaLabelAggregationFunction: 'Función de Agregación',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: ',',
  decimalSeparator: '.'
}					
